import React from 'react'
import "./index.scss";

interface RibbonTemplateProps {
    logo?: string;
    title?: React.ReactNode;
}

const RibbonTemplate: React.FunctionComponent<RibbonTemplateProps> = ({logo, title}) => {
    return (
        <div className="ribbon-template"><img src={logo} /><p className="title" id="banner-page-title">{title}</p></div>
    )
}

RibbonTemplate.defaultProps = {
    logo: "/images/verified-logo.png",
    title: "Verified Management Portal"
}

export default RibbonTemplate
